export enum intelligentColorType {
    // All = 'allSelect',
    // 无颜色时视为整图（全选）
    COLOR = 'color',
    COLOR_PICKER = 'colorPicker',
}

// 一键换色
export interface IIntelligentColorItem {
    color: string;
    txt?: string;
    icon?: string;
    type: intelligentColorType;
}

export interface ISelectInfo extends IIntelligentColorItem {
    index: number;
}

export interface IItIntelligentHSLSelect {
    index?: number;
    info: IIntelligentPreviewItem;
}

export interface IIntelligentPreviewItem {
    url?: string;
    hslPickColors: number[];
    pickColors: string;
    color: any;
    pickFuzziness?: number[];
    fuzziness?: number;
}

export interface IIntelligentEnhanceParams extends IIntelligentPreviewItem {
    isHslSelectAll?: boolean;
    maskCode?: string;
}

// 原名 TAB_KEYS
export enum PEN_TYPE {
    BRUSH = 'brush',
    ERASER = 'eraser',
}

export interface IMaskData {
    imagedata: any;
    width: number;
    height: number;
}

export enum SMART_MASK_PEN_EVENTS {
    drawEnd = 'smart_mask_pen_draw_end',
}

export enum INTELLIGENT_COLOR_CHANGE_EVENT {
    BeforeUndo = 'intelligent_color_change_event_before_undo',
    BeforeRedo = 'intelligent_color_change_event_before_redo',
    Reset = 'intelligent_color_change_event_reset',
    ResetColor = 'intelligent_color_change_event_reset_color',
}
